import moment from 'moment'
import { FC } from 'react'

import { EuiSpacer } from '@elastic/eui'

import { MasterCampaignPlan } from 'api/entities/MasterCampaignPlan'

import Budget from '../Budget'
import RenderCustomSections from '../RenderCustomSections'
import TabPageHeader from '../TabPageHeader'
import AudienceAndGeoTargeting from './AudienceAndGeoTargeting'
import CampaignTimeline from './CampaignTimeline'
import ChannelUtilization from './ChannelUtilization'
import PlanDescription from './PlanDescription'

export interface ExecutiveSummaryProps {
  masterCampaignPlan: MasterCampaignPlan
}

const ExecutiveSummary: FC<ExecutiveSummaryProps> = ({ masterCampaignPlan }) => {
  const campaigns = masterCampaignPlan.masterCampaignStub?.campaignBuilders || []
  const planStartDate = moment(masterCampaignPlan.aiUsedStartDate)
  const planDurationMonths = masterCampaignPlan.aiUsedDurationInMonths
  const section = masterCampaignPlan.executiveSummarySection

  const pageTitle = section?.pageTitle || 'Executive Summary'

  return (
    <>
      <TabPageHeader title={pageTitle} />

      {section?.introduction?.hideAll !== true && (
        <>
          <PlanDescription accountName={masterCampaignPlan.accountName} section={section?.introduction} campaigns={campaigns} />
          <EuiSpacer size='xl' />
        </>
      )}

      <RenderCustomSections sections={section?.aboveCampaignTimeline} />

      <CampaignTimeline campaigns={campaigns} planStartDate={planStartDate} planDurationMonths={planDurationMonths} isClickable={false} isHoverable={false} />

      <EuiSpacer size='xl' />

      <RenderCustomSections sections={section?.aboveChannelUtilization} />

      {section?.channelUtilization?.hideAll !== true && (
        <>
          <ChannelUtilization campaigns={campaigns} section={section?.channelUtilization} />
          <EuiSpacer size='xl' />
        </>
      )}

      <RenderCustomSections sections={section?.aboveAudienceAndGeoSummary} />

      <AudienceAndGeoTargeting masterCampaignPlan={masterCampaignPlan} audienceSection={section?.audienceStrategy} geoSection={section?.geographicTargeting} />
      <EuiSpacer size='xl' />

      <RenderCustomSections sections={section?.aboveBudget} />

      {section?.budget?.hideAll !== true && (
        <>
          <Budget campaigns={campaigns} section={section?.budget} />
          <EuiSpacer size='xl' />
        </>
      )}

      <RenderCustomSections sections={section?.aboveBottom} />
    </>
  )
}

export default ExecutiveSummary
